import { jwtDecode } from "jwt-decode";

export default class JwtUtils {
  public static decode(token: string) {
    try {
      return jwtDecode(token);
    } catch (e) {
      console.error("Error decoding token:", e);
      return undefined;
    }
  }
}
